module.exports = __webpack_public_path__ + "img/3-1.ca67a4a8.svg";